'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const ExportActions = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const exportOptions = [
    { id: 'pdf', label: 'Export as PDF', icon: 'DocumentTextIcon' },
    { id: 'excel', label: 'Export as Excel', icon: 'TableCellsIcon' },
    { id: 'email', label: 'Email Report', icon: 'EnvelopeIcon' },
  ];

  const handleExport = (type: string) => {
    setIsDropdownOpen(false);
    // Export logic would go here
  };

  if (!isHydrated) {
    return (
      <div className="h-10 w-32 bg-muted rounded animate-pulse"></div>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="flex items-center space-x-2 px-4 py-2 bg-surface text-foreground border border-border rounded-lg hover:bg-muted transition-colors duration-200"
      >
        <Icon name="ArrowDownTrayIcon" size={18} />
        <span className="text-sm font-medium">Export</span>
        <Icon name="ChevronDownIcon" size={16} />
      </button>

      {isDropdownOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsDropdownOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-48 bg-popover rounded-lg shadow-brand-lg border border-border z-50 animate-fade-in">
            <div className="py-2">
              {exportOptions.map((option) => (
                <button
                  key={option.id}
                  onClick={() => handleExport(option.id)}
                  className="w-full flex items-center space-x-3 px-4 py-2.5 text-sm font-medium text-foreground hover:bg-surface transition-colors duration-200"
                >
                  <Icon name={option.icon as any} size={18} className="text-muted-foreground" />
                  <span>{option.label}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ExportActions;